export default class PassengerCategory {
    constructor(values) {
        Object.assign(this, values);
        this.id = values.id;
        this.name = values.name;
        this.code = values.code;
        this.description = values.description;
        this.type = TypePassenger[values.type];
        this.typePrice = values.typePrice ? TypePrice[values.typePrice] : null;
        this.order = values.order;
        this.disabled_at = values.disabled_at;
        // si required === true en la venta tiene que llevar esta categoría de pasajero
        this.required = values.required;
        // si minToReserve tiene valor la venta tiene que llevar ese valor de pasajeros de esa categoría
        this.minToReserve = values.minToReserve;
        // si maxToReserve tiene valor el número de pasajeros de esa categoría no puede superar ese valor
        this.maxToReserve = values.maxToReserve;
    }
}
export const TypePassenger = {
    Adult: 'adult',
    Senior: 'senior',
    Child: 'child',
    Infant: 'infant',
    Student: 'student',
    Handicapped: 'handicapped',
    Military: 'military'
};
export const TypePrice = {
    byPassenger: 'byPassenger',
    byGroup: 'byGroup',
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/PassengerCategories/Model.ts
// module id = 57
// module chunks = 0